export default __webpack_public_path__ + "static/media/nosotros.3fa172b5.mp4";